import { Link } from "react-router-dom";
import { Phone } from "@phosphor-icons/react";
import { COMPANY } from "../data/site";

// Primary CTA (deep navy) + phone CTA. Reused across pages.
export function CtaButtons({ className = "", size = "md", stack = false, dark = false }) {
  const pad = size === "lg" ? "px-9 py-4 text-base" : "px-7 py-3.5 text-sm";
  const primary = dark
    ? "bg-white text-[#14183A] hover:shadow-[0_10px_40px_-8px_rgba(255,255,255,0.35)]"
    : "bg-[#14183A] text-white hover:shadow-[0_12px_40px_-10px_rgba(26,73,247,0.55)]";
  const secondary = dark
    ? "border-white/40 bg-transparent text-white hover:bg-white hover:text-[#14183A]"
    : "border-[#E5E5E5] bg-white text-[#14183A] hover:border-[#1A49F7] hover:text-[#1A49F7]";
  return (
    <div className={`flex ${stack ? "flex-col sm:flex-row" : "flex-wrap"} items-center gap-4 ${className}`}>
      <Link
        to="/contact"
        data-testid="cta-contact-button"
        className={`group inline-flex items-center justify-center gap-2 rounded-full font-semibold ${primary} ${pad} transition-all duration-300 hover:scale-[1.03]`}
      >
        Nous contacter
      </Link>
      <a
        href={COMPANY.phoneLink}
        data-testid="cta-call-button"
        className={`inline-flex items-center justify-center gap-2 rounded-full border font-semibold ${secondary} ${pad} transition-all duration-300`}
      >
        <Phone weight="fill" className="h-4 w-4" />
        Appeler le {COMPANY.phone}
      </a>
    </div>
  );
}

export function RgeBadge({ className = "" }) {
  return (
    <span
      data-testid="rge-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-[#FC8529]/40 bg-[#FFF6EF] px-4 py-1.5 text-xs font-semibold tracking-wide text-[#14183A] ${className}`}
    >
      <span className="h-2 w-2 rounded-full bg-[#FC8529]" />
      Artisan RGE — éligible MaPrimeRénov' &amp; CEE
    </span>
  );
}
